import React from 'react';
import { Flex, theme } from 'antd';

export type KpiStatSegment = { value: number; color: string };

export type KpiStatPartitionBarProps = {
  segments: KpiStatSegment[];
};

/**
 * Draws the tile's value as a sum of the stats beside it, segment colors
 * matching their `accent` chips.
 *
 * aria-hidden: every segment's count and share is already text in its own tile.
 */
function KpiStatPartitionBar({ segments }: KpiStatPartitionBarProps) {
  const { token } = theme.useToken();

  const total = segments.reduce((sum, segment) => sum + segment.value, 0);
  // No total means no partition to draw, and the share below would divide by zero.
  if (total <= 0) return null;

  return (
    <Flex
      aria-hidden="true"
      style={{
        height: token.sizeXXS,
        borderRadius: token.borderRadiusSM,
        overflow: 'hidden',
        background: token.colorBorderSecondary,
      }}
    >
      {segments.map((segment) => (
        <div
          key={segment.color}
          style={{
            flex: `0 0 ${(segment.value / total) * 100}%`,
            background: segment.color,
          }}
        />
      ))}
    </Flex>
  );
}

export default KpiStatPartitionBar;
